module.exports = __webpack_public_path__ + "img/Speaker=Ralf Klinkenberg.698859aa.png";